<template>
  <ActionPopoverForm
    :show="show"
    :title="$t('ADVERTISEMENT.ADD_TO_KEYWORDS')"
    class="bids-add-bulk-pricing-table-action-edit"
    @hide="closeAndReset"
    @back="resetAndBack"
    @save="validateAndEditKeywords"
  >
    <ElForm
      :ref="formRefName"
      label-position="left"
      label-width="150px"
      :model="formModel"
      :rules="bidRules"
    >
      <ElFormItem
        prop="matchType"
        :label="$t('ADVERTISEMENT.BULK_IMPORT.PRICING_MATCH_TYPR')"
      >
        <ElSelect v-model="formModel.matchType">
          <ElOption
            v-for="matchType in matchingTypes"
            :key="matchType.property"
            :label="matchType.label"
            :value="matchType.property"
          />
        </ElSelect>
      </ElFormItem>
      <ElFormItem
        prop="priceOffer"
        :label="$t('ADVERTISEMENT.BULK_IMPORT.PRICING_SET_PRICE')"
      >
        <ElInput
          v-model.number="formModel.priceOffer"
          class="el-input-hide-numeric-counter"
          type="number"
        >
          <template #append>
            {{ $t('RIALS') }}
          </template>
        </ElInput>
      </ElFormItem>
    </ElForm>
  </ActionPopoverForm>
</template>

<script>
import { mapActions } from 'vuex';
import { BULK_IMPORT_EDIT_SELECTED_BIDS } from '@/store/types';

import ActionPopoverForm from '../../../../../../common/ActionPopoverForm';
import { matchingTypes } from '../../../../../../common/constants';
import form from '@/mixins/form';
import required from '@/utils/validation-rules/required';
import priceRule from '@/utils/validation-rules/price';

export default {
  name: 'BidsAddBulkPricingTableActionEdit',
  components: {
    ActionPopoverForm,
  },
  mixins: [form],
  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      formModel: {
        matchType: '',
        priceOffer: 0,
      },
    };
  },
  computed: {
    formRefName() {
      return 'editKeywordForm';
    },
    matchingTypes() {
      return matchingTypes;
    },
    bidRules() {
      const requiredRule = {
        ...required(this.$t('VALIDATION_REQUIRED_ERR')),
        trigger: ['blur', 'change'],
      };
      return {
        matchType: requiredRule,
        priceOffer: [requiredRule, priceRule()],
      };
    },
  },
  methods: {
    ...mapActions({
      editBidsInStore: BULK_IMPORT_EDIT_SELECTED_BIDS,
    }),
    closeAndReset() {
      this.reset().then(() => {
        this.close();
      });
    },
    reset() {
      return this.resetForm(this.formRefName);
    },
    resetAndBack() {
      this.reset().then(() => {
        this.$emit('back');
      });
    },
    validateAndEditKeywords() {
      if (!this.isValid(this.formRefName)) return false;

      return this.editKeywords();
    },
    editKeywords() {
      this.editBidsInStore(this.formModel);

      this.closeAndReset();
    },
    close() {
      this.$emit('hide');
    },
  },
};
</script>

<style lang="scss">
.bids-add-bulk-pricing-table-action-edit {
  color: $lb-black;

  .el-form-item__content {
    @include rtl() {
      margin-left: 0 !important;
      margin-right: 150px;
    }
  }
}
</style>
